import LoadingSpinner from '@components/LoadingSpinner';
import { Box, Button, Card } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';

function HeaderCard({
    headline = '',
    subhead = '',
    action = null,
    actionIcon = '',
    actionText = '',
    loading = false,
    small = false,
    sizing = null,
    endSlot = null,
    cardProps = {},
    children
}) {
    sizing = sizing ?? (small ? 'small' : 'default');

    const fontSize = {
        xSmall: {
            xs: '0.9rem',
            md: '1rem',
            xl: '1.05rem'
        },
        small: {
            xs: '1.05rem',
            md: '1.35rem',
            xl: '1.3rem'
        },
        default: {
            xs: '1.2rem',
            md: '1.15rem',
            xl: '1.5rem'
        }
    };

    const padding = {
        xSmall: 1,
        small: 2,
        default: 2.5
    };

    const headlineProps = {
        xSmall: { fontWeight: 400 },
        small: {},
        default: {}
    };

    return (
        <Box width='100%'>
            <Box
                className='HeaderCard'
                mx={{ md: 3.5 }}
                p={padding[sizing]}
                position='relative'
                sx={theme => {
                    return {
                        borderRadius: theme.borders.borderRadius.xl,
                        background: `linear-gradient(135deg, ${theme.palette.primary.main}, ${theme.palette.primary.light})`
                    };
                }}
                zIndex={3}
            >
                <Grid
                    alignItems='center'
                    container
                    flexDirection={{ xs: 'column', md: 'row' }}
                    gap={{
                        xs: 1,
                        md: 2,
                        lg: 4
                    }}
                    justifyContent={{
                        xs: 'center',
                        md: action || endSlot ? 'space-between' : 'flex-start'
                    }}
                    px={2}
                    style={{ height: { xs: 'auto', md: '40px' } }}
                >
                    <Box
                        color='light.main'
                        component='h2'
                        fontSize={{
                            ...fontSize[sizing]
                        }}
                        sx={{
                            wordBreak: 'break-word',
                            ...headlineProps[sizing],
                            order: { xs: 2, md: 1 }
                        }}
                        textAlign='center'
                    >
                        {headline}
                    </Box>

                    {subhead ? (
                        <Box
                            background='#dadada'
                            border='3px solid #dadada'
                            borderRadius='50%'
                            color='light.main'
                            fontSize={{ xs: '0.8rem', md: '0.9rem', lg: '1.1rem' }}
                            fontWeight='bold'
                            height={{ xs: '45px', md: '50px', xl: '55px' }}
                            paddingTop='10px'
                            textAlign='center'
                            width={{ xs: '45px', md: '50px', xl: '55px' }}
                        >
                            {subhead}
                        </Box>
                    ) : null}

                    {action ? (
                        <Button
                            color='light'
                            onClick={action}
                            startIcon={actionIcon}
                            variant='outlined'
                        >
                            {actionText}
                        </Button>
                    ) : null}

                    {endSlot ? (
                        <Box ml={1} sx={{ order: { xs: 1, md: 2 } }}>
                            {endSlot}
                        </Box>
                    ) : null}
                </Grid>
            </Box>

            <Card sx={{ pt: small ? 4.5 : 9, zIndex: 2, mt: small ? -4 : -5, ...cardProps }}>
                {loading ? <LoadingSpinner /> : children}
            </Card>
        </Box>
    );
}

export default HeaderCard;
